import { BrowserRouter, Routes, Route } from "react-router-dom";
import Dashboard from "./Dashboard";
import Viewer from "./Viewer";
import ExcelExportViewer from "./Excelexport";
import Delete from "./Delete";
import Invoice_delete from "./Invoice_delete";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/audit-log" element={<Viewer />} />
        <Route path="/audit-log/:tenant_id" element={<Viewer />} />
        <Route path="/audit-log/:tenant_id/:entity_id" element={<Viewer />} />
        <Route path="/session" element={<Viewer />} />
        <Route path="/session/:tenant_id" element={<Viewer />} />
        <Route path="/session/:tenant_id/:entity_id" element={<Viewer />} />
        <Route path="/excel-export" element={<ExcelExportViewer />} />
        <Route path="/excel-export/:tenant_id" element={<ExcelExportViewer />} />
        <Route path="/application-delete-log" element={<Delete />} />
        <Route path="/application-delete-log/:tenant_id" element={<Delete />} />
        <Route path="/invoice-delete-log" element={<Invoice_delete />} />
        <Route path="/invoice-delete-log/:tenant_id" element={<Invoice_delete />} />
      </Routes>
    </BrowserRouter>
  );
}
export default App;
